import React from 'react';
import { DollarCircleOutlined } from '@ant-design/icons';

const PaymentNotificationIcon = () => <DollarCircleOutlined style={{ color: '#BDBDBD' }} />;

export default PaymentNotificationIcon;
